import React from 'react';

const CLASSIFICATION_STYLES = {
  fast: 'bg-emerald-100 text-emerald-800',
  good: 'bg-emerald-100 text-emerald-800',
  ok: 'bg-amber-100 text-amber-800',
  moderate: 'bg-amber-100 text-amber-800',
  acceptable: 'bg-amber-100 text-amber-800',
  slow: 'bg-red-100 text-red-800',
  poor: 'bg-red-100 text-red-800',
  bad: 'bg-red-100 text-red-800',
};

const formatNumber = (value, digits = 2) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  return value.toFixed(digits);
};

const formatBytesMb = (bytes) => {
  if (typeof bytes !== 'number' || !Number.isFinite(bytes) || bytes <= 0) return null;
  return (bytes / (1024 * 1024)).toFixed(1);
};

const SpeedTestResult = ({ result }) => {
  if (!result) return null;
  const classification = (result.classification || '').toLowerCase();
  const badgeClass = CLASSIFICATION_STYLES[classification] || 'bg-gray-100 text-gray-700';
  const mbStr = formatBytesMb(result.bytes_downloaded);

  return (
    <div className="mt-2 space-y-1">
      <div className="flex items-baseline gap-2 flex-wrap">
        <span className="text-base font-semibold text-gray-900 tabular-nums">
          {formatNumber(result.download_mbps)} Mbps
        </span>
        {result.classification && (
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold uppercase tracking-wide ${badgeClass}`}>
            {result.classification}
          </span>
        )}
        {typeof result.threshold_mbps === 'number' && (
          <span className="text-xs text-gray-500">
            (threshold {result.threshold_mbps} Mbps)
          </span>
        )}
      </div>
      <div className="text-xs text-gray-600 tabular-nums">
        Latency {formatNumber(result.latency_ms, 0)} ms · TTFB {formatNumber(result.ttfb_ms, 0)} ms
      </div>
      {mbStr && (
        <div className="text-xs text-gray-500 tabular-nums">
          {mbStr} MB in {formatNumber(result.duration_s)} s
        </div>
      )}
    </div>
  );
};

export default SpeedTestResult;
